import styled from '@emotion/styled';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslate } from 'hooks/useTranslate';
import formatPriceRange from 'helpers/formatPriceRange';
import formatDuration from 'helpers/formatDuration';
import getLanguageName from 'helpers/getLanguageName';
import dayjs from 'dayjs';
import uk from 'dayjs/locale/uk';

const Wrapper = styled('div')(() => ({}));

const Row = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: 5
}));

const Field = styled(Typography)(() => ({
  fontSize: 15,
  fontWeight: 500,
  color: 'rgba(10, 10, 10, 1)'
}));

const Value = styled(Typography)(() => ({
  fontSize: 15,
  fontWeight: 400,
  color: 'rgba(10, 10, 10, 1)'
}));

const Price = styled(Typography)(() => ({
  fontSize: 19,
  fontWeight: 500,
  marginTop: 12
}));

const CourseAttributes = ({
  duration,
  courseDuration,
  languages = [],
  studyFormat = [],
  minCostValue,
  maxCostValue,
  costCurrency,
  size = 'normal',
  translateNs = 'Courses',
  isFree = false,
  startDate
}) => {
  const t = useTranslate(translateNs);

  const price = formatPriceRange(minCostValue, maxCostValue, costCurrency || 'грн');

  const fieldSx = size === 'card' ? { fontSize: 16 } : undefined;
  const valueSx = size === 'card' ? { fontSize: 16 } : undefined;
  const priceSx = size === 'card' ? { fontSize: 20 } : undefined;

  const readableDuration = formatDuration(duration, t);
  const durationValue = !duration && courseDuration ? courseDuration : readableDuration;
  const hasDuration = durationValue && durationValue.trim() !== '';

  const formattedStartDate = React.useMemo(
    () => (startDate ? dayjs(startDate).locale(uk).format('D MMMM YYYY') : null),
    [startDate]
  );

  return (
    <Wrapper>
      {startDate ? (
        <Row>
          <Field sx={fieldSx}>{t('StartDate')}</Field>
          <Value sx={valueSx}>{formattedStartDate}</Value>
        </Row>
      ) : null}

      {hasDuration ? (
        <Row>
          <Field sx={fieldSx}>{t('Duration')}:</Field>
          <Value sx={valueSx}>{durationValue}</Value>
        </Row>
      ) : null}

      <Row>
        <Field sx={fieldSx}>{t('Language')}:</Field>
        <Value sx={valueSx}>{languages.map(lang => getLanguageName(lang)).join(', ')}</Value>
      </Row>

      <Row>
        <Field sx={fieldSx}>{t('Format')}:</Field>
        <Value sx={valueSx}>{t(studyFormat.join(' | '))}</Value>
      </Row>

      {price ? <Price sx={priceSx}>{price}</Price> : null}

      {isFree ? <Price sx={priceSx}>{t('Free')}</Price> : null}
    </Wrapper>
  );
};

export default CourseAttributes;
